import Swiper, {Navigation, Mousewheel} from 'swiper';

Swiper.use([Navigation, Mousewheel]);

function toggleAccordion() {
    let $items = $('.n-info__faq-item');
    let descriptionClass = 'n-info__faq-item-description';
    let $descriptions = $('.' + descriptionClass);
    let activeClass = 'n-info__faq-item--active';

    $items.on('click', function () {
        let $item = $(this);
        let $description = $item.find('.' + descriptionClass);

        if ($item.hasClass(activeClass)) {
            $descriptions.slideUp();
            $items.removeClass(activeClass);
        } else {
            $descriptions.slideUp();
            $description.slideDown();
            $items.removeClass(activeClass);
            $item.addClass(activeClass);
        }
    });
}

toggleAccordion();

let newsSwiper = new Swiper('.n-info__news-items', {
    slidesPerView: 4,
    spaceBetween: 30,
    slidesPerGroup: 1,
    speed: 300,
    cssMode: true,
    loop: true,
    navigation: {
        nextEl: '.n-info__news-button.n-info__news-button--next',
        prevEl: '.n-info__news-button.n-info__news-button--prev',
    },
    breakpoints: {
        320: {
            slidesPerView: 2,
            spaceBetween: 10
        },
        1280: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
    }
});
